import { FileImage, uploadImages } from '../../services/reportServices'
import { getPendingUploads } from './getPendingUploads'
import { loadImagesFromIndexedDB } from './loadImagesFromIndexedDB'

interface UploadStatus {
  done: boolean,
  error?: Error
  message?: string
}

export async function retryPendingUpload(onProgress: (message: string) => void) {
  const pendingUploads = getPendingUploads()

  const status: UploadStatus[] = Array.from({ length: pendingUploads.length }).map(() => {
    return {
      done: false,
    }
  })
  if (pendingUploads.length > 0) {
    let count = 1
    for (let i = 0; i < pendingUploads.length; i++) {
      onProgress(`${count} de ${pendingUploads.length}`)
      const imagesList: FileImage[] = await Promise.all(
        pendingUploads[i].imagesList.map(async (img) => {
          if (img.indexedDBImageId) {
            const fileImageItem = await loadImagesFromIndexedDB(img.indexedDBImageId)
            return {
              ...img,
              file: fileImageItem,
            }
          }
          return img
        }),
      )

      const result = await uploadImages(
        imagesList,
        pendingUploads[i].reportId,
        undefined,
        pendingUploads[i].imagesToRemove,
        pendingUploads[i].pendingUploadId,
        pendingUploads[i].created_at,
      )

      status[i].done = result.success
      status[i].message = result.message
      status[i].error = result.error

      count++
    }
  }
  return status
}
